import { createDispatchFunction } from 'shared/helpers';
import partial from 'lodash/partial';
import TcRenewalService from './TcRenewalService';
import isEmpty from 'lodash/isEmpty';

// Actions
const GET_TC_CYCLE = 'tcRenewal/GET_TC_CYCLE';
const ACCEPT_AGREEMENT = 'tcRenewal/ACCEPT_AGREEMENT';
const UPDATE_TC_STATUS = 'tcRenewal/UPDATE_TC_STATUS';
const GET_AGREEMENT = 'tcRenewal/GET_AGREEMENT';
const GET_CONTACT_TYPES = 'tcRenewal/GET_CONTACT_TYPES';
const GET_ALTERNATE_CONTACTS = 'tcRenewal/GET_ALTERNATE_CONTACTS';
const UPDATE_ALTERNATE_CONTACT = 'tcRenewal/UPDATE_ALTERNATE_CONTACT';
const SET_ALTERNATE_CONTACT = 'tcRenewal/SET_ALTERNATE_CONTACT';
const GET_TC_CYCLE_CONTACTS = 'tcRenewal/GET_TC_CYCLE_CONTACTS';
const SET_TC_CYCLE_CONTACT = 'tcRenewal/SET_TC_CYCLE_CONTACT';
const REMOVE_TC_CYCLE_CONTACT = 'tcRenewal/REMOVE_TC_CYCLE_CONTACT';
const UPDATE_TC_CYCLE = 'tcRenewal/UPDATE_TC_CYCLE';
const UPDATE_TC_CYCLE_DATA = 'tcRenewal/UPDATE_TC_CYCLE_DATA';
const GET_DIGITAL_ASSESSMENT_QUESTIONS = 'tcRenewal/GET_DIGITAL_ASSESSMENT_QUESTIONS';
const GET_DIGITAL_ASSESSMENT_ANSWERS = 'tcRenewal/GET_DIGITAL_ASSESSMENT_ANSWERS';
const SET_DIGITAL_ASSESSMENT_ANSWER = 'tcRenewal/SET_DIGITAL_ASSESSMENT_ANSWER';
const REMOVE_DIGITAL_ASSESSMENT_ANSWER = 'tcRenewal/REMOVE_DIGITAL_ASSESSMENT_ANSWER';
const GET_AVAILABLE_RENEWAL_DATES = 'tcRenewal/GET_AVAILABLE_RENEWAL_DATES';
const GET_TC_CYCLE_EVENTS = 'tcRenewal/GET_TC_CYCLE_EVENTS';
const SET_TC_CYCLE_EVENTS = 'tcRenewal/SET_TC_CYCLE_EVENTS';

const initialState = {
  tcCycle: {},
  agreement: {},
  contactTypes: [],
  alternateContacts: [],
  secureStorageContacts: [],
  secureMaterialsTransfContacts: [],
  secureMaterialsReceiptContacts: [],
  secureMaterialsCheckinContacts: [],
  secureAdministerTestContacts: [],
  secureMaterialsReturnContacts: [],
  availableRenewalDates: [],
  tcCycleEvents: [],
  loadingTcCycleEvents: false,
  digitalAssessmentQuestions: [],
  loadingContacts: false,
  errorSetContact: {},
  errorRemovingContact: {},
  errorAcceptAgreement: {},
};

const mapContacts = [
  'alternateContacts',
  'secureStorageContacts',
  'secureMaterialsTransfContacts',
  'secureMaterialsReceiptContacts',
  'secureMaterialsCheckinContacts',
  'secureAdministerTestContacts',
  'secureMaterialsReturnContacts',
];

const filterAgreement = list => list.find(agreem => agreem.type === 'coordinator');

// Reducer
export default function tcRenewalReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TC_CYCLE: {
      if (action.result.data && action.result.data.id !== state.tcCycle.id) {
        return {
          ...initialState,
          tcCycle: action.result.data || {},
        };
      }
      return {
        ...state,
        tcCycle: action.result.data || {},
      };
    }
    case ACCEPT_AGREEMENT:
      return {
        ...state,
        errorAcceptAgreement: action.result.error,
      };
    case UPDATE_TC_STATUS:
      return {
        ...state,
        tcCycle: action.result.data || [],
      };
    case GET_AGREEMENT:
      return {
        ...state,
        agreement: action.result.data ? filterAgreement(action.result.data) : {},
      };
    case GET_ALTERNATE_CONTACTS:
      return {
        ...state,
        ...action.result,
        alternateContacts: action.result.data,
        alternateContactsLoaded: true,
      };
    case GET_TC_CYCLE_CONTACTS: {
      if (!action.result.data) {
        if (action.result.payload) {
          const idx = action.result.payload.typeId;
          return {
            ...state,
            [mapContacts[idx - 1]]: [],
            loadingContacts: action.result.loading,
          };
        } else {
          return {
            ...state,
            loadingContacts: action.result.loading,
          };
        }
      }
      const idx = (action.result.payload && action.result.payload.typeId) || action.result.data[0].contactType.id;
      return {
        ...state,
        [mapContacts[idx - 1]]: action.result.data,
        loadingContacts: action.result.loading,
      };
    }
    case SET_TC_CYCLE_CONTACT:
      return {
        ...state,
        errorSetContact: action.result.error,
      };
    case REMOVE_TC_CYCLE_CONTACT:
      return {
        ...state,
        errorRemovingContact: action.result.error,
      };
    case UPDATE_TC_CYCLE:
      return {
        ...state,
        tcCycle: {
          ...state.tcCycle,
          ...action.result.data,
        },
      };
    case UPDATE_TC_CYCLE_DATA:
      return {
        ...state,
        tcCycle: {
          ...state.tcCycle,
          ...action.result.data,
        },
      };
    case SET_ALTERNATE_CONTACT:
      return {
        ...state,
        ...action.result,
        alternateContacts: action.result.data ? [action.result.data] : [],
      };
    case UPDATE_ALTERNATE_CONTACT:
      return {
        ...state,
        ...action.result,
        alternateContacts: action.result.data ? [action.result.data] : [],
      };
    case GET_CONTACT_TYPES:
      return {
        ...state,
        contactTypes: action.result.data || [],
      };
    case GET_DIGITAL_ASSESSMENT_QUESTIONS:
      return {
        ...state,
        digitalAssessmentQuestions: action.result.data,
      };
    case GET_DIGITAL_ASSESSMENT_ANSWERS:
      return {
        ...state,
        digitalAssessmentAnswers: action.result.data,
      };
    case SET_DIGITAL_ASSESSMENT_ANSWER:
      return {
        ...state,
        errorSetAssessmentAnswer: action.result.error,
      };
    case REMOVE_DIGITAL_ASSESSMENT_ANSWER:
      return {
        ...state,
        errorRemovingAssessmentAnswer: action.result.error,
      };
    case GET_AVAILABLE_RENEWAL_DATES:
      return {
        ...state,
        availableRenewalDates: action.result.data || [],
      };
    case GET_TC_CYCLE_EVENTS:
      return {
        ...state,
        tcCycleEvents: action.result.data || [],
        loadingTcCycleEvents: action.result.loading,
      };
    case SET_TC_CYCLE_EVENTS:
      return {
        ...state,
        tcCycleEvents: action.result.data || state.tcCycleEvents,
        loadingTcCycleEvents: action.result.loading,
        errorTCEvents: action.result.error,
      };
    default:
      return state;
  }
}

// Action Creators
export function getTcCycleAction(result) {
  return { type: GET_TC_CYCLE, result };
}

export function getCoordinatorAgreementAction(result) {
  return { type: GET_AGREEMENT, result };
}

export function acceptAgreementAction(result) {
  return { type: ACCEPT_AGREEMENT, result };
}

export function updateTcStatusAction(result) {
  return { type: UPDATE_TC_STATUS, result };
}

export function getTcCycleContactsAction(result) {
  return { type: GET_TC_CYCLE_CONTACTS, result };
}

export function setTcCycleContactAction(result) {
  return { type: SET_TC_CYCLE_CONTACT, result };
}

export function removeTcCycleContactAction(result) {
  return { type: REMOVE_TC_CYCLE_CONTACT, result };
}

export function updateTCCycleAction(result) {
  return { type: UPDATE_TC_CYCLE, result };
}

export function updateTCCycleDataAction(result) {
  return { type: UPDATE_TC_CYCLE_DATA, result };
}

export function getAlternateContactsAction(result) {
  return { type: GET_ALTERNATE_CONTACTS, result };
}

export function setAlternateContactsAction(result) {
  return { type: SET_ALTERNATE_CONTACT, result };
}

export function updateAlternateContactsAction(result) {
  return { type: UPDATE_ALTERNATE_CONTACT, result };
}

export function getContactTypesAction(result) {
  return { type: GET_CONTACT_TYPES, result };
}

export function getDigitalAssessmentQuestionsAction(result) {
  return { type: GET_DIGITAL_ASSESSMENT_QUESTIONS, result };
}

export function getDigitalAssessmentAnswersAction(result) {
  return { type: GET_DIGITAL_ASSESSMENT_ANSWERS, result };
}

export function setDigitalAssessmentAnswerAction(result) {
  return { type: SET_DIGITAL_ASSESSMENT_ANSWER, result };
}

export function removeDigitalAssessmentAnswerAction(result) {
  return { type: REMOVE_DIGITAL_ASSESSMENT_ANSWER, result };
}

export function getAvailableRenewalDatesAction(result) {
  return { type: GET_AVAILABLE_RENEWAL_DATES, result};
}

export function getTcCycleEventsAction(result) {
  return { type: GET_TC_CYCLE_EVENTS, result};
}

export function setTcCycleEventsAction(result) {
  return { type: SET_TC_CYCLE_EVENTS, result};
}


// Action dispatcher functions

export function getTcCycle(tcCycleId) {
  return createDispatchFunction(
    partial(TcRenewalService.getTcCycle, tcCycleId),
    getTcCycleAction
  );
}

export function getCoordinatorAgreement(userId, status, cycleId) {
  return createDispatchFunction(
    partial(TcRenewalService.getCoordinatorAgreement, userId, status, cycleId),
    getCoordinatorAgreementAction
  );
}

export function acceptAgreement(userId, termsId) {
  return createDispatchFunction(
    partial(TcRenewalService.acceptAgreement, userId, termsId),
    acceptAgreementAction
  );
}

export function updateTcStatus(tcCycleId, status) {
  return createDispatchFunction(
    partial(TcRenewalService.updateTestCenterStatus, tcCycleId, status),
    updateTcStatusAction
  );
}

export function getAlternateContacts(tcCycleId, contactTypeId) {
  return createDispatchFunction(
    partial(TcRenewalService.getTcCycleContacts, tcCycleId, contactTypeId),
    getAlternateContactsAction
  );
}


export function setAlternateContacts(data) {
  return createDispatchFunction(
    partial(TcRenewalService.setTcCycleContact, data),
    setAlternateContactsAction
  );
}

export function updateAlternateContacts(data) {
  return createDispatchFunction(
    partial(TcRenewalService.updateTcCycleContact, data),
    updateAlternateContactsAction
  );
}

export function getContactTypes() {
  return createDispatchFunction(
    partial(TcRenewalService.getContactTypes),
    getContactTypesAction
  );
}

export function getTcCycleContacts(tcCycleId, contactTypeId) {
  return createDispatchFunction(
    partial(TcRenewalService.getTcCycleContacts, tcCycleId, contactTypeId),
    getTcCycleContactsAction, {typeId: contactTypeId}
  );
}

export function updateTCCycle(cycleData) {
  return createDispatchFunction(
    partial(TcRenewalService.updateTCCycle, cycleData),
    updateTCCycleAction
  );
}

export function updateTCCycleData(cycleData) {
  return createDispatchFunction(
    partial(TcRenewalService.updateTCCycleData, cycleData),
    updateTCCycleDataAction
  );
}

export function setTcCycleContact(contact) {
  return createDispatchFunction(
    partial(TcRenewalService.setTcCycleContact, contact),
    setTcCycleContactAction
  );
}

export function removeTcCycleContact(contactId) {
  return createDispatchFunction(
    partial(TcRenewalService.removeTcCycleContact, contactId),
    removeTcCycleContactAction
  );
}

export function getDigitalAssessmentQuestions(params) {
  return createDispatchFunction(
    partial(TcRenewalService.getDigitalAssessmentQuestions, params),
    getDigitalAssessmentQuestionsAction
  );
}

export function getDigitalAssessmentAnswers(params) {
  return createDispatchFunction(
    partial(TcRenewalService.getDigitalAssessmentAnswers, params),
    getDigitalAssessmentAnswersAction
  );
}

export function setDigitalAssessmentAnswer(params) {
  return createDispatchFunction(
    partial(TcRenewalService.setDigitalAssessmentAnswer, params),
    setDigitalAssessmentAnswerAction
  );
}

export function removeDigitalAssessmentAnswer(params) {
  return createDispatchFunction(
    partial(TcRenewalService.removeDigitalAssessmentAnswer, params),
    removeDigitalAssessmentAnswerAction
  );
}

export function getAvailableRenewalDates(tcCycleId) {
  return createDispatchFunction(
    partial(TcRenewalService.getAvailableRenewalDates, tcCycleId),
    getAvailableRenewalDatesAction
  );
}

export function getTcCycleEvents(tcCycleId) {
  return createDispatchFunction(
    partial(TcRenewalService.getTcCycleEvents, tcCycleId),
    getTcCycleEventsAction
  );
}

export function setTcCycleEvents(tcCycleId, data) {
  return createDispatchFunction(
    partial(TcRenewalService.setTcCycleEvents, tcCycleId, data),
    setTcCycleEventsAction
  );
}

